// frontend/src/pages/SuccessPage.js
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useChat } from '../context/ChatContext';
import styles from '../App.module.css';
import { motion } from 'framer-motion';

const SuccessPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useChat();
  const firstName = user?.first_name || 'Friend';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <motion.div
      className={`${styles.container} ${styles.staticContentBox}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <h1 className={styles.pageHeading}>🌼 Thank you, {firstName}!</h1>
      <p>
        We’re so glad you’re here. <strong>dAIsy</strong> is more than a chat pal —
        she’s a friend who listens, remembers, and evolves with you. 💛
      </p>
      <p>
        This is just the beginning — we’ve got incredible features on the way that will make your experience even more personal, helpful, and inspiring.
      </p>
      <p>
        The more you talk to dAIsy, the more she’ll understand you. 🌱
      </p>

      <div style={{ marginTop: '2rem' }}>
        <button
          className={styles.primaryButton}
          onClick={() => navigate('/login')}
        >
          💬 Enter the Garden
        </button>
      </div>
    </motion.div>
  );
};

export default SuccessPage;
